import type { DestinoInicio } from './HomePage';
import { EncabezadoPantalla } from '@/ui/Sistema';

/** Lo que vive detrás de «Más», en el orden en que se usa. */
const SECCIONES: {
  destino: DestinoInicio | 'reportes' | 'equipo' | 'cuenta';
  rotulo: string;
  nota: string;
}[] = [
  { destino: 'reportes', rotulo: 'Reportes', nota: 'Exportaciones del período' },
  { destino: 'equipo', rotulo: 'Equipo', nota: 'Personas y participantes' },
  { destino: 'config', rotulo: 'Configuración', nota: 'Movilidad, repartos y organización' },
  // Va última y con nombre propio. Google Play exige que la baja de cuenta se
  // pueda hacer desde adentro de la aplicación, y una puerta de salida
  // escondida dentro de «Configuración» no es una puerta: es un laberinto con
  // una salida.
  { destino: 'cuenta', rotulo: 'Mi cuenta', nota: 'Sesión y baja de la cuenta' },
];

/**
 * «Configuración y más».
 *
 * El cajón de lo que se usa de vez en cuando. Tiene sólo lo que **no** está en
 * Inicio: repetir ahí las mismas seis secciones era darle al mismo lugar dos
 * nombres distintos, y obligaba a recordar cuál de los dos caminos se había
 * tomado la vez anterior.
 */
export function MasPage({
  onIr,
}: {
  onIr: (destino: DestinoInicio | 'reportes' | 'equipo' | 'cuenta') => void;
}) {
  return (
    <div className="flex flex-col gap-5 p-4" data-testid="mas">
      <EncabezadoPantalla titulo="Configuración y más" />
      {/* Una lista de destinos y nada más. Sin grilla secundaria: Inicio ya es
          la grilla, y dos tableros distintos obligan a recordar por cuál se
          entró la vez anterior. */}
      <ul className="flex flex-col divide-y divide-[var(--linea)]">
        {SECCIONES.map((s) => (
          <li key={s.destino}>
            <button
              type="button"
              onClick={() => onIr(s.destino)}
              className="flex min-h-16 w-full items-center justify-between gap-3 text-left"
              data-testid={`mas-${s.destino}`}
            >
              <span className="min-w-0">
                <span className="block font-medium">{s.rotulo}</span>
                <span className="block text-sm text-[var(--tinta-suave)]">{s.nota}</span>
              </span>
              <span className="shrink-0 text-[var(--tinta-tenue)]" aria-hidden>
                ›
              </span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
